import {Observable, OperatorFunction} from 'rxjs';
import {mapTo, startWith, switchMap} from 'rxjs/operators';

export function repeatIf<T>(manualAction: Observable<void>): OperatorFunction<T, T> {
  return switchMap((x: T) => {
    return manualAction.pipe(
      startWith(undefined), // to let the element pass by itself
      mapTo(x),
    );
  });
}
